<template>
  <div
    class="qr-generator"
  >
    <h2>Generate QR codes for all your habits! Select size and click download.</h2>
    <div v-if="display" style="position: absolute; left: 0; top: 1200px">
      <div
        class="QRSWrapper"
        ref="document"
        style="display: flex; flex-wrap: wrap"
      >
        <div
          style="text-align: center"
          class="qr-item"
          v-for="(habit, i) in habitToShow"
          :key="i"
        >
          <QrcodeVue
            :size="size / 2"
            id="dynamicIllustration"
            :value="getShortUrl(habit)"
            level="H"
          />
          <p>{{ habit.name }}</p>
        </div>
      </div>
    </div>
    <button @click="exportToPDF">Export to PDF</button>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import html2pdf from 'html2pdf.js';
import { mapActions, mapState } from 'vuex';
import habitHelper from '../helpers/habitHelper';

export default {
  name: 'app',
  components: {
    QrcodeVue,
  },
  data() {
    return {
      display: false,
      size: 250,
      habitToShow: [],
    };
  },
  computed: {
    ...mapState({
      // get only active habits
      activityHabits: (state) => state.habitsDashboard.activityHabits,
    }),
  },
  async mounted() {
    await this.getAllHabits();
    this.habitToShow = this.activeHabits();
  },
  methods: {
    ...mapActions({
      getAllHabits: 'habitsDashboard/getAllHabits',
    }),
    activeHabits() {
      return habitHelper.activeHabits(this.$moment(), this.activityHabits);
    },
    getShortUrl(habit) {
      return `${window.location.origin}/short?id=${habit.globalId}`;
    },
    async exportToPDF() {
      const opt = {
        filename: 'qr-code',
        image: {
          type: 'jpeg', // jpg, jpeg, bmp, png
          quality: 1.0,
        },
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          windowWidth: '297mm',
          windowHeight: '210mm',
          allowTaint: true,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait', // landscape sau portrait
          compress: true,
        },
        pagebreak: {
          mode: 'css',
          // mode: ["avoid-all", "css", "legacy"],
          before: '.break-before',
          after: '.break-after',
          avoid: '.break-avoid',
        },
      };

      this.display = true;
      setTimeout(() => {
        html2pdf(this.$refs.document, opt);
      }, 50);
      setTimeout(() => {
        this.display = false;
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
.qr-generator {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: auto;
  text-align: center;

  button {
    background-color: #4CAF50; /* Green */
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin-top: 30px;
  }

  h2 {
    margin-top: 70px;
    padding: 10px;
    font-size: 20px;
    font-weight: 700;
  }
}
.qr-item {
  margin: 5px;
  color: black;
}
.QRSWrapper img {
  width: var(--size);
  margin: 5px 10px;
}
</style>
